import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../../../../../../app/redux/hooks';
import {
  clearVehicleDetails,
  getVehicleSingleDetailsAction
} from '../../../../../../../../../features/yaantrac/redux/reducer/yaantracSlices/vehicleList';
import {
  map,
  updateCenter,
  updateZoom
} from '../../../../../../../../redux/reducer/commonSlices/mapSlice';
import { distanceChart } from '../chartInitialState';
import { epochToDateFormat } from '../../../../../../../../../utils/commonFunctions';

export const useVehicleDetailsHooks = ({
  setIsOpen,
  vehicleDetails,
  vehicleData
}: any) => {
  const dispatch = useAppDispatch();
  const [details, setDetails] = useState<any>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [secondaryDetails, setSecondaryDetails] = useState<any>(null);
  const [distanceDetails, setDistanceDetails] = useState(distanceChart);
  const handleCloseDetails = () => {
    setIsOpen(false);
    setDetails(null);
    setSecondaryDetails(null);
  };
  const insertSpaceBeforeUppercase = (inputString: string) => {
    return inputString.replace(/(?<!^)(?=[A-Z])/g, ' ');
  };

  useEffect(() => {
    if (details?.overallDistanceResponseList) {
      const days = details?.overallDistanceResponseList?.map((item: any) =>
        item?.timeInterval.split(' - ')[0].split('-').join('/')
      );

      const distanceKM = details?.overallDistanceResponseList?.map((item: any) =>
        Number(item?.distance.toFixed(2))
      );

      setDistanceDetails((prev: any) => ({
        ...prev,
        xAxis: { ...prev.xAxis, categories: days },
        series: [{ ...prev.series[0], data: distanceKM }]
      }));
    }
  }, [details?.overallDistanceResponseList?.length]);

  useEffect(() => {
    if (vehicleData.data) {
      setDetails(vehicleData.data);
      const value: any = vehicleData.data;
      const selectedData = {
        vehicleModel: value.vehicleModel,
        vehicleColor: value.vehicleColor,
        vehicleCategory: value.vehicleCategory,
        lastServicedDate: value.lastServicedDate
          ? epochToDateFormat(value.lastServicedDate / 1000)
          : 'N/A',
        yearOfPurchase: value.yearOfPurchase,
        insuranceExpiryDate: value.insuranceExpiryDate
          ? epochToDateFormat(value.insuranceExpiryDate / 1000)
          : 'N/A'
      };
      setSecondaryDetails([selectedData]);
    }
  }, [vehicleData]);

  useEffect(() => {
    if (vehicleDetails !== null)
      dispatch(getVehicleSingleDetailsAction(vehicleDetails.vehicleNumber));
  }, [vehicleDetails]);

  useEffect(() => {
    return () => {
      dispatch(clearVehicleDetails());
      dispatch(map([]));
    };
  }, []);

  useEffect(() => {
    if (details?.lastUpdateLatitude) {
      let marker = [
        {
          id: 1,
          vehicleNo: details?.vehicleNumber?.toUpperCase(),
          lat: details?.lastUpdateLatitude,
          lng: details?.lastUpdateLongitude,
          name: 'report',
          type: 'myplace',
          info: {
            Mylocation: `${details?.vehicleNumber}`,
            lat: details?.lastUpdateLatitude,
            lng: details?.lastUpdateLongitude
          }
        }
      ];
      if (vehicleData.isLoading) {
        dispatch(map([]));
        dispatch(updateZoom([]));
        dispatch(updateCenter([]));
      } else {
        dispatch(map(marker));
        dispatch(updateZoom(marker));
        dispatch(updateCenter(marker));
      }
    }
  }, [details?.lastUpdateLatitude, vehicleData.isLoading]);

  return {
    handleCloseDetails,
    details,
    open,
    setOpen,
    secondaryDetails,
    distanceDetails,
    insertSpaceBeforeUppercase
  };
};
